import React from 'react'
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from '@mui/material/styles'
// import { colors } from '@mui/material'
import PropTypes from 'prop-types'

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 767,
      md: 1024,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      dark: '#16375a',
      main: '#20446b',
      light: '#20446b26',
    },
    secondary: {
      main: '#ab003c',
    },
    white: {
      light: '#fff',
      main: '#E6E6E6',
    },
    red: {
      main: '#e81809',
    },
    blue: {
      main: '#16375a',
    },
    background: {
      default: '#f3f3f3',
    },
  },
  props: {
    MuiTextField: {
      variant: 'outlined',
      autocomplete: 'off',
    },
    MuiInput: {
      variant: 'outlined',
    },
    MuiFormControl: {
      variant: 'outlined',
    },
    MuiButton: {
      variant: 'contained',
    },
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            paddingLeft: `20px`,
            background: `#ebf2f9`,
            color: `#000`,
          },
          '&.MuiListItemButton-root:hover': {
            color: `#fff`,
          },
        },
      },
    },
  },
})

const CustomThemeVariables = (props) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
    </StyledEngineProvider>
  )
}

CustomThemeVariables.propTypes = {
  children: PropTypes.any,
}

export default CustomThemeVariables
